var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',[_c('a',{ref:"accordion",staticClass:"accordion collapsed",on:{"click":function($event){return _vm.click()}}},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('div',{staticClass:"card-arrow"})]),_c('div',{staticClass:"panel"},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }